module.exports = __webpack_public_path__ + "img/arubaProduct.f1085fd9.png";